import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { useCookieConsent } from '../../contexts/CookieConsentContext';
import { Button } from '../ui/Button';
export function CookieBanner() {
  const {
    decided,
    choices,
    panelOpen,
    save,
    closePanel
  } = useCookieConsent();
  const [analytics, setAnalytics] = useState(choices.analytics);
  const [marketing, setMarketing] = useState(choices.marketing);
  const [showDetails, setShowDetails] = useState(false);
  const visible = !decided || panelOpen;
  useEffect(() => {
    setAnalytics(choices.analytics);
    setMarketing(choices.marketing);
    if (panelOpen) setShowDetails(true);
  }, [choices, panelOpen]);
  return <AnimatePresence data-id="element-363" data-mp="1ehxuhcv409oi">
      {visible && <motion.div role="dialog" aria-label="Cookie preferences" initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 16
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-4 bottom-4 z-[60] mx-auto max-w-xl rounded-lg border border-line bg-white p-6 shadow-lift" data-id="element-364" data-mp="2293cnyoive1z">
          <h2 className="font-display text-2xl font-semibold text-ink" data-id="element-365" data-mp="18mxyu4qddpr8">Your privacy choices</h2>
          <p className="mt-2 text-sm leading-relaxed text-muted" data-id="element-366" data-mp="13u4v9k6n0ngq">
            This site currently uses only essential storage to remember this choice. No analytics or marketing cookies are active. Read our{' '}
            <Link to="/legal/cookies" className="text-royal underline underline-offset-2" data-id="element-367" data-mp="1dk7kd9an1h9s">
              Cookie Policy
            </Link>
            .
          </p>
          {showDetails && <div className="mt-4 space-y-3 rounded-md bg-ivory p-4 text-sm" data-id="element-368" data-mp="1nk8611vzc9h5">
              <label className="flex items-center justify-between gap-4" data-id="element-369" data-mp="3tblshkgcf8oh">
                <span className="text-ink" data-id="element-370" data-mp="3pajpcsjb2ch8">Essential (always on)</span>
                <input type="checkbox" checked disabled className="h-4 w-4 accent-[#0A1426]" data-id="element-371" data-mp="3pccvm6q0auop" />
              </label>
              <label className="flex items-center justify-between gap-4" data-id="element-372" data-mp="1sca24vz98h60">
                <span className="text-ink" data-id="element-373" data-mp="1x9ijwvghqj6q">Analytics (not currently used)</span>
                <input type="checkbox" checked={analytics} onChange={e => setAnalytics(e.target.checked)} className="h-4 w-4 accent-[#0A1426]" data-id="element-374" data-mp="227ae5w4lyhe3" />
              </label>
              <label className="flex items-center justify-between gap-4" data-id="element-375" data-mp="2b91lf5esqwa2">
                <span className="text-ink" data-id="element-376" data-mp="2b6xf6gtfdl6m">Marketing (not currently used)</span>
                <input type="checkbox" checked={marketing} onChange={e => setMarketing(e.target.checked)} className="h-4 w-4 accent-[#0A1426]" data-id="element-377" data-mp="2g61rhgbnbz16" />
              </label>
            </div>}
          <div className="mt-5 flex flex-wrap gap-2" data-id="element-378" data-mp="2pwwbsf5c0ojz">
            <Button size="sm" variant="navy" onClick={() => save({
          analytics: false,
          marketing: false
        })} data-id="element-379" data-mp="2uxajfw30twhh">
              Essential only
            </Button>
            {showDetails ? <Button size="sm" variant="outline" onClick={() => save({
          analytics,
          marketing
        })} data-id="element-380" data-mp="naqwrkjebza8">
                Save preferences
              </Button> : <Button size="sm" variant="outline" onClick={() => setShowDetails(true)} data-id="element-381" data-mp="jbry2ho9cyr8">
                Manage
              </Button>}
            {decided && <button type="button" onClick={closePanel} className="ml-auto text-sm text-muted hover:text-ink" data-id="element-382" data-mp="9cso8vrrax2n">
                Close
              </button>}
          </div>
        </motion.div>}
    </AnimatePresence>;
}